import { useParams } from 'react-router-dom'
import { useHostServices } from '../HostServices'
import { useApiAuth } from '../utils/api-auth'
import { formatDateForApi } from '../utils/formatter'
import { useAcsFetch } from '../hooks/use-acs-fetch'
import { useFeatureFlags } from '../hooks/use-feature-flags'
import { Flags } from '../utils/feature-flags'

export const useSearchTransactionsApi = (): any => {
  const acsFetch = useAcsFetch()
  const { utils } = useHostServices()
  const { cif, guid } = useApiAuth()

  const ffTransactionSearchApigee = useFeatureFlags(
    Flags.TransactionSearchApigee,
  )

  const { id } = useParams<{ id: string }>()

  const fetchSearchTransactions = async (values: any): Promise<any> => {
    const startDate = formatDateForApi(values.startDate)
    const toDate = formatDateForApi(values.toDate)
    const encodedKeyword = encodeURIComponent(values.keywords)

    if (ffTransactionSearchApigee) {
      const result = await acsFetch<Record<string, any>>(
        `/v1/bank-accounts/transactions/${id}?fromDate=${startDate}&toDate=${toDate}&transactionDescription=${encodedKeyword}`,
      )

      // istanbul ignore else - low value, UI code handles no results
      if (result.data) {
        return result.data
      }
    }

    if (cif && guid) {
      const result = await utils.fetch.CAPI({
        url: `/accounts/${id}/transactions?fromDate=${startDate}&toDate=${toDate}&transactionDescription=${encodedKeyword}`,
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          cif,
          guid,
        },
      } as any)
      if (result.response.ok) {
        return result.payload
      }
    }
    throw new Error('cif and guid failed')
  }

  return {
    fetchSearchTransactions,
  }
}
